import { formatDate } from 'date-fns';
import bolt3D from '~/images/bolt-3d.png';
import boltCloud from '~/images/cloud.png';
import { HACKATHON_URL } from '~/lib/urls';
import { classNames } from '~/utils/classNames';

import styles from './BoltNewAnnouncement.module.scss';

interface Announcement {
  link: string;
  text: string;
  logo?: string;
  logoImage?: string;
  liveUntil?: Date;
  needChevron?: boolean;
}

const events: Announcement[] = [
  {
    link: 'http://bolt.fyi/cloud',

    // logo: 'i-bx:cloud',
    logoImage: boltCloud,
    text: 'Introducing Bolt Cloud!',
    liveUntil: new Date('2025-08-21T00:00:00.000Z'),
  },

  {
    link: HACKATHON_URL,
    logoImage: bolt3D,
    text: 'Join the world’s largest Hackathon!',
    needChevron: true,

    // valid until June 30, 2pm PST
    liveUntil: new Date('2025-06-30T21:00:00.000Z'),
  },
  {
    link: 'https://x.com/boltdotnew/status/1920524313171546315',
    logo: 'i-bx:bxl-github',
    text: 'Introducing GitHub integration!',
    liveUntil: new Date('2025-06-01T00:00:00.000Z'),
  },

  {
    link: 'https://x.com/boltdotnew/status/1915054917410238513',
    logo: 'i-bolt:artiste-palette',
    text: 'New Design capabilities in Bolt!',
    liveUntil: new Date('2025-06-01T00:00:00.000Z'),
  },

  {
    link: 'https://www.addevent.com/event/cS24696394',
    logo: 'i-bolt:tear-off-calendar',
    text: `${formatDate(new Date('2025-02-12T17:00:00.000Z'), 'LLL do @ haaa')}: Add Stripe to your Bolt app`,

    // valid until February 12, 10am PT
    liveUntil: new Date('2025-02-12T18:00:00.000Z'),
  },

  // default value
  {
    link: 'https://x.com/stackblitz/status/1841873251313844631',
    logo: 'i-bolt:logos-x?mask',
    text: 'Introducing bolt.new: Dev sandbox with AI from StackBlitz',
    liveUntil: new Date('2025-06-01T00:00:00.000Z'),
  },
];

export function BoltNewAnnouncement() {
  const info = pickCurrentEvent(events);

  return (
    info && (
      <a
        href={info.link}
        className={classNames(
          styles.LiquidGlassButton,
          'absolute left-1/2 top-[100px] -translate-x-1/2 w-max min-w-fit max-w-[calc(100%-var(--chat-padding))] group',
          'flex items-center gap-2 rounded-full px-5 py-[7px] text-sm font-medium z-10',
        )}
        target="_blank"
      >
        {/* Light refraction overlay */}
        <span className={styles.LightRefraction} />

        {/* Animated gradient border */}
        <span className={styles.GradientBorder} />

        {/* Content */}
        {info.logo && (
          <span className={classNames(info.logo, 'size-5 text-bolt-elements-textPrimary shrink-0 relative z-10')} />
        )}
        {info.logoImage && (
          <img src={info.logoImage} alt="" className="h-6 text-bolt-elements-textPrimary shrink-0 relative z-10" />
        )}
        <span className="flex items-center gap-0.5 relative z-10">
          {info.text}
          {info.needChevron && (
            <span className="i-bolt:chevron-down -rotate-90 text-bolt-elements-textSecondary size-4 shrink-0" />
          )}
        </span>
      </a>
    )
  );
}

function pickCurrentEvent(events: Announcement[]): Announcement {
  const today = new Date();

  return events.find(({ liveUntil }) => !liveUntil || today < liveUntil)!;
}
